export default {
  // عام
  common: {
    back: 'عودة',
    confirm: 'تأكيد',
    continue: 'متابعة',
    cancel: 'إلغاء',
    retry: 'إعادة المحاولة',
    total: 'المجموع',
    profile: 'المركز الشخصي',
    history: 'السجل',
    pleaseLogin: 'يرجى تسجيل الدخول أولاً',
    my: 'حسابي',
    appName: 'قائمة الطعام الذكية بالذكاء الاصطناعي',
    loading: 'جاري التحميل...',
    lang: 'اختر اللغة',
    loadFailed: 'فشل التحميل',
    operationFailed: 'فشلت العملية',
    notSet: 'غير محدد',
    country: 'الدولة',
    all: 'الكل',
    searchPlaceholder: 'عنصر نائب للبحث',
    noMore: 'لا يوجد المزيد'
  },

  // الصفحة الرئيسية
  home: {
    allFoods: 'كل الأطباق',
    headline: {
      sub: 'ما لا تعرفه عن',
      main: 'مأكولات {country}'
    },
    articleTag: 'دليل',
    localGuideTitle: 'دليل محلي',
    recommendedArticlesAll: 'الكل',
    hotTopics: 'مواضيع الطعام الشائعة',
    orderCallout: 'لا مزيد من الطلب بقول "this, this"!',
    mustEatBadge: 'قائمة لا تفوت',
    countrySelect: {
      eyebrow: 'وجهة السفر',
      title: 'يرجى اختيار الدولة',
      subtitle: 'لمطابقة إلهام الطعام والأدلة المناسبة لك',
      footer: 'يمكنك التبديل في أي وقت من أعلى اليسار'
    },
    loadCountriesFailed: 'فشل تحميل الدول'
  },

  // المفضلة
  favorites: {
    title: 'المفضلة',
    empty: 'لا توجد مفضلات',
    foods: 'أطباق',
    articles: 'أدلة'
  },

  articleList: {
    title: 'أدلة {country}',
    empty: 'لا توجد أدلة موصى بها'
  },

  // تفاصيل الطبق
  dishDetail: {
    quantity: 'الكمية',
    introduction: 'مقدمة الطبق',
    loadingIntroduction: 'جاري الحصول على المقدمة...',
    getIntroduction: 'عرض المقدمة',
    addToCart: 'إضافة للسلة ({count} حصة)',
    selectQuantity: 'يرجى اختيار الكمية',
    addedToCart: 'تمت إضافة {count} حصة للسلة',
    loadFailed: 'فشل الحصول على المقدمة',
    noImage: 'لا توجد صورة',
    imageSearchEmpty: 'لم يتم العثور على صورة مطابقة للطبق',
    imageSearchAction: 'ابحث عن الصور',
    aiImageGenerating: 'الذكاء الاصطناعي يولد الصورة',
    generating: 'جاري التوليد'
  },

  // شريط التبويب
  tabbar: {
    home: 'الرئيسية',
    cameraOrder: 'الطلب بالصور',
    favorites: 'المفضلة',
    profile: 'حسابي',
    camera: 'تصوير',
    menu: 'القائمة'
  },

  // صفحة الكاميرا
  camera: {
    translate: 'ترجمة إلى',
    takeOrUpload: 'اضغط للتصوير أو الرفع',
    uploadHint: 'يدعم صور متعددة، بحد أقصى 9',
    addMore: 'إضافة المزيد',
    order: 'بدء الطلب',
    selectLanguage: 'اختر لغة الترجمة',
    singleMode: 'وضع فردي',
    multiMode: 'وضع متعدد',
    history: 'السجل',
    takePhotoError: 'فشل التصوير، يرجى المحاولة مرة أخرى',
    cameraUnsupported: 'الكاميرا غير مدعومة',
    cameraPermissionDenied: 'إذن الكاميرا مرفوض، يرجى تفعيله في الإعدادات',
    capture: 'متابعة التصوير',
    tapToCapture: 'اضغط للتصوير',
    tapToStart: 'اضغط لبدء التصوير',
    readyToCapture: 'تصوير القائمة',
    uploading: 'جاري الرفع...',
    uploadFailed: 'فشل الرفع',
    pleaseCapture: 'يرجى التقاط صورة أولاً',
    maxPhotosReached: 'الحد الأقصى 9 صور',
    photosAdded: 'تمت إضافة {count} صورة',
    confirmUpload: 'تأكيد الرفع',
    uploadMessage: 'سيتم رفع {count} صورة للتعرف على القائمة',
    startRecognition: 'بدء التعرف',
    confirmRecognition: 'تأكيد التعرف',
    willRecognize: 'سيتم التعرف على {count} صورة للقائمة',
    continueShooting: 'متابعة التصوير',
    prepareUpload: 'تحضير الرفع...',
    compressingImage: 'جاري ضغط الصورة...',
    compressionFailed: 'فشل الضغط',
    useOriginal: 'استخدام الأصلية',
    takePhoto: 'اضغط للتصوير',
    selectFromGallery: 'من المعرض',
    operationFailed: 'فشلت العملية، يرجى المحاولة مرة أخرى',
    processingPhoto: 'جاري معالجة الصورة...',
    leavingPageWarning: 'جاري معالجة الصور، هل أنت متأكد من المغادرة؟',
    restoreInfoMissing: 'تم اكتشاف معلومات {count} صورة سابقة لكن البيانات مفقودة، يرجى إعادة التصوير',
    addedAndSkipped: 'تمت إضافة {added}، وتخطي {skipped} ملف غير صورة',
    remainingQuotaNotice: 'المستخدم المحترم {phone}: مدة صلاحية الاشتراك: {days}',
    guide: {
      step1: 'تصوير القائمة',
      step2: 'تعرف وترجمة AI',
      step3: 'توليد القائمة'
    }
  },

  // تسجيل الدخول
  login: {
    title: 'تسجيل الدخول',
    phone: 'رقم الهاتف',
    code: 'رمز التحقق',
    phoneNumber: 'رقم الهاتف',
    verifyCode: 'رمز التحقق',
    sendCode: 'إرسال الرمز',
    resend: 'إعادة الإرسال',
    login: 'دخول',
    loggingIn: 'جاري الدخول...',
    success: 'تم الدخول بنجاح',
    failed: 'فشل الدخول، يرجى المحاولة لاحقاً',
    loginSuccess: 'تم الدخول بنجاح',
    loginFailed: 'فشل الدخول',
    phonePlaceholder: 'أدخل رقم الهاتف',
    codePlaceholder: 'أدخل رمز التحقق',
    phoneRequired: 'يرجى إدخال رقم الهاتف',
    codeRequired: 'يرجى إدخال رمز التحقق',
    phoneInvalid: 'صيغة رقم الهاتف غير صحيحة',
    codeInvalid: 'رمز التحقق يجب أن يكون 4-6 أرقام',
    phoneError: 'صيغة رقم الهاتف غير صحيحة',
    codeError: 'صيغة رمز التحقق غير صحيحة',
    codeSent: 'تم إرسال الرمز',
    resendCode: 'إعادة الإرسال',
    countdown: 'إعادة المحاولة بعد {count} ثانية',
    retryAfter: 'إعادة المحاولة بعد {seconds} ثانية',
    tooFrequent: 'الإرسال متكرر جداً، يرجى المحاولة لاحقاً',
    dailyLimit: 'تجاوزت الحد اليومي للإرسال',
    sendFailed: 'فشل الإرسال، يرجى المحاولة لاحقاً',
    agreeTips: 'تسجيل الدخول يعني الموافقة على اتفاقية المستخدم وسياسة الخصوصية'
  },

  // القائمة
  menu: {
    title: 'القائمة',
    cartTitle: 'سلة المشتريات',
    checkout: 'إتمام الطلب',
    totalItems: 'المجموع {count} عنصر',
    clearCart: 'إفراغ السلة',
    emptyCart: 'السلة فارغة',
    aiRecommend: 'توصيات AI',
    addToCart: 'إضافة للسلة',
    viewDetail: 'عرض التفاصيل',
    price: 'السعر',
    quantity: 'الكمية',
    currentMenu: 'القائمة الحالية',
    clearCartConfirm: 'هل أنت متأكد من إفراغ السلة؟',
    noMenuData: 'يرجى تصوير القائمة أولاً',
    confirmButton: 'تأكيد',
    cancelButton: 'إلغاء',
    hint: 'تلميح',
    noMenuItemsFound: 'لم يتم التعرف على عناصر القائمة'
  },

  // توصيات AI
  ai: {
    recommendedSets: 'مجموعات موصى بها',
    dishCount: 'طبق',
    selectSetHint: 'يرجى اختيار مجموعة موصى بها',
    noSelectedDishes: 'يرجى اختيار الأطباق أولاً',
    setPrefix: 'مجموعة',
    others: 'أخرى',
    diningOptions: 'تفضيلات الطعام',
    numberOfPeople: 'عدد الأشخاص',
    dietaryPreferences: 'التفضيلات الغذائية',
    budgetRange: 'نطاق الميزانية',
    getRecommendation: 'ساعدني في الطلب AI',
    noSpicy: 'بدون حار',
    vegetarian: 'نباتي',
    seafood: 'مأكولات بحرية',
    meat: 'لحوم',
    loading: 'جاري توليد التوصيات...',
    recommendationTitle: 'توصيات AI لك',
    tastePreference: 'تفضيلات المذاق',
    budgetPerPerson: 'الميزانية للفرد',
    allergyWarning: 'قيود غذائية (مسببات الحساسية)',
    sweet: 'حلو',
    sour: 'حامض',
    spicy: 'حار',
    bitter: 'مر',
    umami: 'أومامي',
    light: 'خفيف',
    heavy: 'دسم',
    dairy: 'ألبان',
    eggs: 'بيض',
    fish: 'سمك',
    shellfish: 'قشريات',
    treeNuts: 'مكسرات',
    peanuts: 'فول سوداني',
    wheat: 'قمح',
    soy: 'فول الصويا',
    selectOptions: 'يرجى اختيار تفضيلات الطعام',
    peopleCountError: 'عدد الأشخاص يجب أن يكون 1 أو أكثر',
    budgetRangeError: 'نطاق الميزانية يجب أن يكون عدداً صحيحاً موجباً',
    budgetMaxMinError: 'الميزانية القصوى يجب أن تكون أكبر من أو تساوي الدنيا',
    submitFailed: 'فشل الإرسال، يرجى المحاولة مرة أخرى',
    minBudget: 'أدنى ميزانية',
    maxBudget: 'أقصى ميزانية',
    to: 'إلى',
    yuan: 'يوان',
    recommendProgress: 'تقدم توصيات AI',
    analyzing: 'جاري تحليل القائمة...',
    generating: 'جاري توليد خطة التوصية...',
    recommendReason: 'سبب التوصية',
    menuCombination: 'تشكيلة القائمة',
    dietaryNotes: 'نصائح غذائية',
    servingSize: 'عدد الحصص المقترح',
    viewDetail: 'التفاصيل',
    goToCheckout: 'إتمام الطلب',
    dish: 'حصة',
    menuOption: 'مجموعة',
    recommendedDishes: 'أطباق موصى بها',
    categoryDishes: 'أطباق حسب الفئة',
    order: 'طلب',
    orderConversation: 'محادثة الطلب'
  },

  // الرفع
  upload: {
    title: 'جاري التعرف',
    uploading: 'جاري الرفع...',
    recognizing: 'جاري التعرف على القائمة...',
    translating: 'جاري الترجمة...',
    generating: 'جاري توليد النتائج...',
    complete: 'اكتمل التعرف',
    failed: 'فشل التعرف',
    progress: 'التقدم',
    detailsTitle: 'تفاصيل التعرف',
    retake: 'إعادة التصوير',
    retryUpload: 'إعادة الرفع',
    buyBenefits: 'ترقية المزايا',
    uploadingNow: 'جاري الرفع',
    aiRecognizingImages: 'AI يتعرف على الصور',
    aiTranslatingMenu: 'AI يترجم القائمة',
    dynamicCompression: 'ضغط الصور ديناميكياً',
    ocrEngineIntegration: 'تكامل محرك OCR',
    agentEngineBoot: 'بدء تشغيل محرك الوكيل',
    llmContextParsing: 'تحليل سياق LLM',
    ragTargetLanguage: 'مطابقة لغة الهدف RAG',
    cuisineRegionMapping: 'رسم خرائط المطبخ والمنطقة',
    enhancedTranslation: 'بدء الترجمة المحسنة',
    dishMetadataClassification: 'تصنيف البيانات الوصفية للأطباق',
    semanticUiConstruction: 'بناء واجهة المستخدم الدلالية',
    confirmCancelTitle: 'تأكيد الإلغاء',
    confirmCancelMessage: 'هل أنت متأكد من إلغاء التعرف؟',
    preparingCount: 'جاري تحضير {count} صورة...',
    startUploadCount: 'بدء رفع {count} صورة',
    processingComplete: 'اكتملت المعالجة',
    navigatingSoon: 'جاري الانتقال...',
    processingCompleteAndNavigate: 'اكتملت المعالجة، جاري الانتقال',
    createBackgroundTask: 'جاري إنشاء مهمة في الخلفية...',
    noPhotoFound: 'لم يتم العثور على بيانات الصور',
    pleaseRetake: 'يرجى العودة لإعادة التصوير',
    dataParseFailed: 'فشل تحليل البيانات',
    photoDataParseFailed: 'فشل تحليل بيانات الصورة',
    photoDataFormatError: 'خطأ في تنسيق بيانات الصورة، يرجى إعادة التصوير',
    uploadFailedShort: 'فشل الرفع',
    failedShort: 'فشل',
    errorTryAgain: 'فشلت المعالجة، يرجى المحاولة مرة أخرى',
    menuNotFound: 'لم يتم التعرف على القائمة، يرجى إعادة التصوير',
    otherLlmErr: 'فشل ترجمة القائمة',
    finalizing: 'جاري العمل على ترجمة القائمة',
    almostDone: 'قارب على الانتهاء، يرجى الانتظار'
  },

  // الأخطاء
  error: {
    network: 'خطأ في الشبكة، يرجى التحقق من الاتصال',
    server: 'خطأ في الخادم، يرجى المحاولة لاحقاً',
    timeout: 'انتهت مهلة الطلب، يرجى المحاولة مرة أخرى',
    unknown: 'خطأ غير معروف',
    auth: 'فشل المصادقة، يرجى تسجيل الدخول مجدداً',
    selectImage: 'يرجى اختيار ملف صورة',
    imageTooLarge: 'لا يمكن أن تتجاوز الصورة 20 ميجابايت',
    processPhotoFailed: 'فشل معالجة الصورة، يرجى المحاولة مرة أخرى',
    processFileFailed: 'فشل معالجة الملف',
    pageStateError: 'حالة الصفحة غير طبيعية، يرجى إعادة التصوير',
    processingPhotos: 'جاري معالجة الصور، يرجى الانتظار...',
    livePhotoNotSupported: 'يرجى اختيار صورة عادية، Live Photo غير مدعومة',
    microphonePermissionDenied: 'تم رفض إذن الميكروفون، يرجى السماح به في إعدادات المتصفح',
    microphoneNotFound: 'لم يتم العثور على جهاز ميكروفون',
    microphoneInUse: 'الميكروفون مستخدم من قبل تطبيق آخر',
    microphoneConfigNotSupported: 'الميكروفون لا يدعم التكوين المطلوب',
    recordingNotSupported: 'المتصفح لا يدعم التسجيل',
    recordingError: 'حدث خطأ أثناء التسجيل',
    forbidden: 'ليس لديك صلاحية الوصول',
    notFound: 'المورد المطلوب غير موجود',
    requestFailed: 'فشل الطلب',
    configError: 'خطأ في تكوين الطلب'
  },

  // محادثة الطلب
  orderConversation: {
    title: 'محادثة الطلب',
    menu_order: 'طلب',
    quantity: 'الكمية',
    translatedText: 'نص الترجمة',
    orderText: 'نص الطلب',
    userSpeak: 'اضغط واستمر للتحدث',
    waiterSpeak: 'اضغط واستمر للتحدث',
    customerSpeak: 'اضغط واستمر للتحدث',
    waiterSpec: 'نادل',
    customerSpec: 'زبون',
    dish_detail: 'تفاصيل',
    recording: 'جاري التسجيل...',
    common_confirm: 'تأكيد',
    customerRecording: 'الزبون يتحدث...',
    recognizing: 'جاري التعرف...',
    translating: 'جاري الترجمة...',
    recordingFailed: 'فشل التسجيل، يرجى التحقق من إذن الميكروفون',
    recognitionFailed: 'فشل التعرف الصوتي',
    translationFailed: 'فشلت الترجمة',
    recognitionResult: 'نتيجة التعرف',
    blankAudio: 'وقت التحدث قصير جداً',
    noDishes: 'لم يتم اختيار أطباق',
    assistantIntro: 'مرحباً، أنا مساعد الطلب للزبون. الزبون يرغب في طلب الأطباق التالية. اضغط للاستماع للرسالة، أو اضغط مطولاً على الزر السفلي للتحدث وسأقوم بالترجمة.'
  },

  // الملف الشخصي
  profile: {
    title: 'حسابي',
    memberCard: {
      title: 'مزايا العضوية',
      dynamicTitle: 'أنت حالياً مستخدم {status}<br />تتمتع بالمزايا التالية:',
      feature1: ' تعرف دقيق على القائمة',
      feature2: ' ترجمة لأكثر من 20 لغة',
      feature3: ' طلب بتوصية AI',
      feature4: ' مقدمة أطباق عالمية',
      feature5: ' ترجمة محادثة صوتية مستمرة',
      featureUsageTemplate: '{feature} ({count})',
      unlock: 'فتح الآن',
      unlockBenefits: 'ترقية باقة المزايا'
    },
    menu: {
      privacy: 'سياسة الخصوصية',
      terms: 'اتفاقية المستخدم',
      feedback: 'ملاحظات واقتراحات',
      serviceStatus: 'حالة الخدمة',
      about: 'حول'
    },
    redeem: {
      button: 'استبدال المزايا',
      title: 'استبدال المزايا',
      description: 'يرجى إدخال رمز الاستبدال لتفعيل المزايا.',
      placeholder: 'أدخل رمز الاستبدال',
      helper: 'يدعم الأحرف A-Z والأرقام 0-9. يتم تجاهل المسافات ولا يهم اختلاف حالة الأحرف.',
      submit: 'استبدال الآن',
      cancel: 'إلغاء',
      success: 'تم الاستبدال بنجاح، تم تحديث المزايا',
      validation: {
        empty: 'يرجى إدخال رمز الاستبدال أولاً',
        length: 'رمز الاستبدال يجب أن يكون 12 خانة من أحرف وأرقام',
        format: 'صيغة رمز الاستبدال غير صحيحة',
        checksum: 'فشل التحقق من رمز الاستبدال، يرجى التأكد والمحاولة مجدداً'
      }
    },
    register: 'حذف الحساب',
    registerHint: 'وظيفة الحذف قيد التطوير',
    logout: 'تسجيل الخروج',
    logoutConfirm: {
      title: 'تسجيل الخروج',
      message: 'هل أنت متأكد من تسجيل الخروج؟'
    },
    logoutSuccess: 'تم تسجيل الخروج'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'فتح مزايا طلب AI',
    columns: {
      feature: 'قائمة المقارنة'
    },
    plans: {
      freeUser: 'مستخدم مجاني',
      trial: 'تجربة مجانية',
      trialTag: 'تجربة لفترة محدودة',
      oneDay: 'باقة اشتراك يوم واحد',
      twoDay: 'باقة اشتراك يومين',
      threeDay: 'باقة استمتاع 3 أيام',
      fiveDay: 'باقة استمتاع 5 أيام'
    },
    actions: {
      tryNow: 'انقر للتجربة',
      purchase: 'انقر للشراء',
      continueTrial: 'متابعة التجربة',
      trialUnavailable: 'انتهت التجربة',
      renew: 'تجديد الآن',
      subscribed: 'مشترك'
    },
    features: {
      validity: 'الصلاحية المتبقية',
      price: 'السعر',
      usageCount: 'عدد مرات المزايا',
      aiTranslate: 'ترجمة القائمة AI',
      aiTextDetail: 'تفاصيل الطبق\nنسخة نصية',
      aiRecommend: 'طلب بتوصية AI',
      aiOrder: 'مساعدة الطلب AI',
      aiVoice: 'ترجمة المحادثة الصوتية'
    },
    values: {
      days: '{count} يوم',
      lifetime: 'مدى الحياة',
      free: '0',
      price: '{amount} يوان',
      times: '{count} مرة',
      notAvailable: '-',
      comingSoon: '- (سيتم فتحها تباعاً)'
    },
    remarkTitle: 'شرح المزايا',
    remarksText:
      '1. الدول المغطاة في ترجمة القائمة: آسيا: اليابان، كوريا الجنوبية، تايلاند، فيتنام، سنغافورة، ماليزيا، إندونيسيا، الإمارات، تركيا؛ أوروبا: المملكة المتحدة، فرنسا، ألمانيا، النمسا، سويسرا، إيطاليا، أيرلندا، إسبانيا، البرتغال، روسيا، التشيك، المجر، كرواتيا، هولندا، رومانيا، السويد؛ أمريكا الشمالية: الولايات المتحدة، كندا، المكسيك؛ أمريكا الجنوبية: البرازيل، الأرجنتين، تشيلي، الأوروغواي، الباراغواي، كولومبيا، فنزويلا، بنما، بيرو، الإكوادور؛ أخرى: أستراليا، نيوزيلندا.' +
      '\nملاحظة: سويسرا تدعم الألمانية والفرنسية والإيطالية؛ النمسا تدعم الألمانية فقط؛ أمريكا الجنوبية (باستثناء البرازيل) تدعم الإسبانية.' +
      '\n2. تملك الشركة حق تفسير محتوى الصفحة والقواعد، ويجب أن يتبع التفسير القوانين واللوائح ويحمي الحقوق القانونية للمستخدمين.',
    toast: {
      trialRedirect: 'جاري نقلك لتفعيل التجربة الكاملة',
      purchaseRedirect: 'جاري نقلك لشراء المزايا',
      contactAdmin: 'يرجى الاتصال بالمسؤول لفتح خدمة العضوية',
      noQuota: 'وصلت عدد مرات الاستخدام للحد الأقصى، يرجى شراء المزايا من صفحة "حسابي"',
      subscriptionExpired: 'انتهت صلاحية عضويتك أو وصل الاستخدام للحد الأقصى، يرجى التجديد من صفحة "حسابي"',
      trialExhausted: 'انتهت مرات التجربة، يرجى شراء مزايا العضوية من صفحة "حسابي"',
      wechatRequired: 'يرجى استخدام متصفح WeChat المدمج لإتمام الدفع',
      paySuccess: 'تم الدفع بنجاح، تم تحديث المزايا',
      payCancelled: 'تم إلغاء الدفع',
      payFailed: 'فشل الدفع، يرجى المحاولة لاحقاً',
      payPending: 'يتم تأكيد نتيجة الدفع، يرجى التحقق من حالة الطلب لاحقاً',
      productUnavailable: 'هذا المنتج غير متاح للشراء حالياً، يرجى المحاولة لاحقاً'
    },
    currentBenefits: 'الباقة الحالية',
    moreDetails: 'المزيد من التفاصيل',
    remainingBenefits: 'المزايا المتبقية',
    totalBenefits: 'إجمالي المزايا',
    expireTime: 'وقت انتهاء المزايا',
    tabs: {
      compare: 'مقارنة',
      detail: 'تفاصيل'
    },
    upgradeTitle: 'ترقية المزايا',
    trialNoteTitle: 'شرح مزايا التجربة',
    trialNoteText: 'يمكن لأعضاء التجربة تجربة ترجمة القائمة والميزات الأخرى. فترة التجربة لا تؤثر على مزايا الاشتراك.',
    statusDetail: {
      title: 'تفاصيل الخطة',
      planName: 'اسم الخطة',
      startTime: 'تاريخ البدء',
      expireTime: 'تاريخ الانتهاء',
      totalCount: 'إجمالي العدد',
      status: 'الحالة',
      statusMap: {
        pending: 'بانتظار التفعيل',
        active: 'نشط',
        invalid: 'منتهي الصلاحية'
      }
    },
    durations: {
      oneDay: 'يوم واحد',
      twoDay: 'يومين',
      threeDay: '٣ أيام',
      fiveDay: '٥ أيام'
    },
    subscriptionSuffix: 'اشتراك',
    subscriptionName: 'اشتراك {duration}',
    fiveDayDesc: 'صلاحية 5 أيام',
    validityOnly: 'صلاحية {duration}',
    validityAndUsage: 'صلاحية {duration}، تتضمن {usage} من مزايا الاستخدام',
    usageCountSimple: 'عدد الاستخدام'
  }
}
